import gql from 'graphql-tag';

/** Nigerian states with their LGAs, for the state-of-origin / LGA dropdowns (#574). */
export const GET_NIGERIAN_STATES = gql`
  query NigerianStateList {
    nigerianStates { name lgas }
  }
`;
